import { CampoDinamico } from '../campo-dinamico';
import { Classificazione } from '../classificazione';
import { Codice } from '../tipologiche/codice';
import { MotivoDefinizione } from '../tipologiche/motivo-definizione';
import { SoggettoPratica } from '../tipologiche/soggetto-pratica';
import { StatoEntita } from '../tipologiche/stato-entita';
import { TipoMotivazione } from '../tipologiche/tipo-motivazione';
import { TipoPratica } from '../tipologiche/tipo-pratica';
import { TipoVisibilita } from '../tipologiche/tipo-visibilita';

export class Pratica {
  id: string;
  tipoPratica: TipoPratica;
  stato: StatoEntita;
  correlata: boolean;
  definito: boolean;
  capofila: boolean;
  riunita: boolean;
  motivoDefinizione: MotivoDefinizione;
  dataDefinizione: number;
  dataArchiviazione: number;
  posizione: string;
  vecchiaPosizione: string;
  note: string;
  dataApertura: number;
  soggetto: SoggettoPratica;
  tipoVisibilita: TipoVisibilita;
  archiviata: boolean;
  classificazioni: Classificazione[];
  campiDinamici: CampoDinamico[];
  conflittoDiInteressi: boolean;
  recuperoCrediti: boolean;
  oggetto: string;
  numeroProtocollo: string;
  numeroFascicoloProtocollo: string;
  codice:Codice;
}
